import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7cd7c672 = () => interopDefault(import('../../../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _a106494c = () => interopDefault(import('../../../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _8f374372 = () => interopDefault(import('../../../pages/design-services.vue' /* webpackChunkName: "pages/design-services" */))
const _e32e3b8e = () => interopDefault(import('../../../pages/diagrams/index.vue' /* webpackChunkName: "pages/diagrams/index" */))
const _7fa67850 = () => interopDefault(import('../../../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _f808d578 = () => interopDefault(import('../../../pages/know-how.vue' /* webpackChunkName: "pages/know-how" */))
const _70427a22 = () => interopDefault(import('../../../pages/newsletter.vue' /* webpackChunkName: "pages/newsletter" */))
const _181c5944 = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _279e945a = () => interopDefault(import('../../../pages/subscription.vue' /* webpackChunkName: "pages/subscription" */))
const _e96c947e = () => interopDefault(import('../../../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _3617050a = () => interopDefault(import('../../../pages/wishlist.vue' /* webpackChunkName: "pages/wishlist" */))
const _5df2f30d = () => interopDefault(import('../../../pages/checkout/data.vue' /* webpackChunkName: "pages/checkout/data" */))
const _615d667b = () => interopDefault(import('../../../pages/checkout/order.vue' /* webpackChunkName: "pages/checkout/order" */))
const _019163f3 = () => interopDefault(import('../../../pages/checkout/payment.vue' /* webpackChunkName: "pages/checkout/payment" */))
const _6a1cc27d = () => interopDefault(import('../../../pages/checkout/plan/data.vue' /* webpackChunkName: "pages/checkout/plan/data" */))
const _4b24f5ea = () => interopDefault(import('../../../pages/checkout/plan/order.vue' /* webpackChunkName: "pages/checkout/plan/order" */))
const _77141e83 = () => interopDefault(import('../../../pages/checkout/plan/payment.vue' /* webpackChunkName: "pages/checkout/plan/payment" */))
const _5aa90c42 = () => interopDefault(import('../../../pages/checkout/plan/welcome.vue' /* webpackChunkName: "pages/checkout/plan/welcome" */))
const _3d6810e8 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _8f34ff18 = () => interopDefault(import('../../../pages/checkout/download/_key.vue' /* webpackChunkName: "pages/checkout/download/_key" */))
const _5d20fe64 = () => interopDefault(import('../../../pages/diagrams/slides/_url.vue' /* webpackChunkName: "pages/diagrams/slides/_url" */))
const _e9d96c72 = () => interopDefault(import('../../../pages/catalog/_tag.vue' /* webpackChunkName: "pages/catalog/_tag" */))
const _48636942 = () => interopDefault(import('../../../pages/category/_category.vue' /* webpackChunkName: "pages/category/_category" */))
const _8e7c4c06 = () => interopDefault(import('../../../pages/diagrams/_diagram.vue' /* webpackChunkName: "pages/diagrams/_diagram" */))
const _062886ca = () => interopDefault(import('../../../pages/s/_query.vue' /* webpackChunkName: "pages/s/_query" */))
const _4ab251e0 = () => interopDefault(import('../../../pages/slides/_url_title.vue' /* webpackChunkName: "pages/slides/_url_title" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _7cd7c672,
    name: "about"
  }, {
    path: "/contact",
    component: _a106494c,
    name: "contact"
  }, {
    path: "/design-services",
    component: _8f374372,
    name: "design-services"
  }, {
    path: "/diagrams",
    component: _e32e3b8e,
    name: "diagrams"
  }, {
    path: "/faq",
    component: _7fa67850,
    name: "faq"
  }, {
    path: "/know-how",
    component: _f808d578,
    name: "know-how"
  }, {
    path: "/newsletter",
    component: _70427a22,
    name: "newsletter"
  }, {
    path: "/search",
    component: _181c5944,
    name: "search"
  }, {
    path: "/subscription",
    component: _279e945a,
    name: "subscription"
  }, {
    path: "/terms",
    component: _e96c947e,
    name: "terms"
  }, {
    path: "/wishlist",
    component: _3617050a,
    name: "wishlist"
  }, {
    path: "/checkout/data",
    component: _5df2f30d,
    name: "checkout-data"
  }, {
    path: "/checkout/order",
    component: _615d667b,
    name: "checkout-order"
  }, {
    path: "/checkout/payment",
    component: _019163f3,
    name: "checkout-payment"
  }, {
    path: "/checkout/plan/data",
    component: _6a1cc27d,
    name: "checkout-plan-data"
  }, {
    path: "/checkout/plan/order",
    component: _4b24f5ea,
    name: "checkout-plan-order"
  }, {
    path: "/checkout/plan/payment",
    component: _77141e83,
    name: "checkout-plan-payment"
  }, {
    path: "/checkout/plan/welcome",
    component: _5aa90c42,
    name: "checkout-plan-welcome"
  }, {
    path: "/",
    component: _3d6810e8,
    name: "index"
  }, {
    path: "/checkout/download/:key?",
    component: _8f34ff18,
    name: "checkout-download-key"
  }, {
    path: "/diagrams/slides/:url?",
    component: _5d20fe64,
    name: "diagrams-slides-url"
  }, {
    path: "/catalog/:tag?",
    component: _e9d96c72,
    name: "catalog-tag"
  }, {
    path: "/category/:category?",
    component: _48636942,
    name: "category-category"
  }, {
    path: "/diagrams/:diagram",
    component: _8e7c4c06,
    name: "diagrams-diagram"
  }, {
    path: "/s/:query?",
    component: _062886ca,
    name: "s-query"
  }, {
    path: "/slides/:url_title?",
    component: _4ab251e0,
    name: "slides-url_title"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
